<template>
  <div class="integrations-container">
    <div class="row middle-xs">
      <div class="col-xs-9 integrations-header">
        You can connect Parlay to any of the following LMS / SIS tools. These
        will allow you to roster teachers, students, and courses. For the LMSs,
        teachers will also be able to roster their classes, connect assignments,
        and sync assessment data and feedback.
      </div>
      <div class="col-xs-3">
        <pl-button
          class="w-100 b"
          :class="[enableIntegrations ? 'enable-integrations' : 'pl-primary']"
          @click.native="setUpIntegrations"
          style="font-size: 20px; min-height: 45px"
        >
          ENABLE INTEGRATIONS
          <i
            v-if="enableIntegrations"
            class="fa fa-check ml4"
            aria-hidden="true"
          />
        </pl-button>
        <pl-button
          class="w-100 b pl-primary"
          :disabled="!enableIntegrations"
          @click.native="manageIntegrations"
          style="font-size: 20px; min-height: 45px"
        >
          MANAGE INTEGRATIONS
        </pl-button>
      </div>
    </div>
    <div></div>
    <div>
      <integrations-table
        :providers="providers"
        @import_courses_modal="getEdlinkSchoolIntegrationTeachers"
        @add_integration_id="getEdlinkProviders"
      />
    </div>
    <!-- <integrations-courses-modal
      v-if="import_courses_modal"
      :courses="courses"
      :selectedCourses="selectedCourses"
      :integration_id="integration_id"
      :integration_name="integration_name"
      @filters="searchAndFilters"
      @admin-portal-filter-changed="resetFilters"
      @scroll-on-table="handleScroll(page_number)"
      @close="resetCourses"
      @load_edlink_courses="getEdlinkSchoolIntegrationCourses"
    /> -->
    <integrations-teachers-modal
      v-if="import_courses_modal"
      :teachers="teachers"
      :selectedTeachers="selectedTeachers"
      :integration_id="integration_id"
      :integration_name="integration_name"
      :loading_data="loading_data"
      @filters="searchAndFilters"
      @admin-portal-filter-changed="resetFilters"
      @scroll-on-table="handleScroll"
      @close="resetCourses"
      @load_edlink_courses="getEdlinkSchoolIntegrationTeachers"
    />
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import integrationsTable from './integrationsTable.vue';
  import integrationsCoursesModal from './integrationsCoursesModal.vue';
  import integrationsTeachersModal from './integrationsTeachersModal.vue';
  import adminServices from 'services/admin/adminServices';

  export default {
    components: {
      integrationsTable,
      integrationsCoursesModal,
      integrationsTeachersModal,
    },
    data() {
      return {
        edLinkMetadata: {},
        providers: [],
        import_courses_modal: false,
        courses: [],
        selectedCourses: [],
        integration_id: '',
        integration_name: '',
        filters: {
          first_name: '',
          last_name: '',
          teacher_email: '',
          parlay_account: '',
        },
        // filters: {
        //   course_title: '',
        //   teacher_email: '',
        //   subject: '',
        //   school_site: '',
        //   grade: '',
        //   is_connected: '',
        // },
        page_number: 1,
        courses_page_size: 10,
        show_more_courses: true,
        teachers: [],
        selectedTeachers: [],
        show_more_teachers: true,
        next_page: '',
        loading_data: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentSchool']),
      enableIntegrations() {
        return this.providers.find((p) => p.school_connected === true);
      },
    },
    methods: {
      getEdLinkMetadata() {
        const schoolID = { schoolID: this.$route.params.schoolID };
        this.$store
          .dispatch('getEdlinkMetadata', schoolID)
          .then((res) => (this.edLinkMetadata = res));
      },
      setUpIntegrations() {
        if (this.edLinkMetadata.setup_integrations_link) {
          sessionStorage.setItem(
            'admin_integrations_school_id',
            this.$route.params.schoolID
          );
          window.open(this.edLinkMetadata.setup_integrations_link, '_self');
        }
      },
      manageIntegrations() {
        if (this.edLinkMetadata.manage_integrations_link) {
          window.open(this.edLinkMetadata.manage_integrations_link, '_blank');
        }
      },
      getEdlinkProviders() {
        const schoolID = { schoolID: this.$route.params.schoolID };
        this.$store
          .dispatch('getEdlinkSchoolProviders', schoolID)
          .then((data) => (this.providers = data));
      },
      getEdlinkSchoolIntegrationCourses(
        integration_id,
        integration_name,
        page,
        is_filter
      ) {
        this.filters.page = page ? page : this.page_number;

        if (this.filters.page === 1) {
          this.resetFilters();
        }

        const payload = {
          schoolID: this.$route.params.schoolID,
          integrationID: integration_id,
          filters: this.filters,
        };
        this.$store
          .dispatch('getEdlinkSchoolIntegrationCourses', payload)
          .then((data) => {
            if (is_filter) {
              this.courses = [];
            }
            if (data && data.length > 0) {
              this.courses.push(...data);
              if (data.length === this.courses_page_size) {
                this.page_number += 1;
              } else {
                this.show_more_courses = false;
              }
            } else {
              this.show_more_courses = false;
            }
            this.integration_id = integration_id;
            this.integration_name = integration_name;
            this.import_courses_modal = true;
          })
          .catch((err) => {
            console.error(err);
            EventBus.$emit('toast-msg', 'Failure. Please try again.');
          });
      },
      async getEdlinkSchoolIntegrationTeachers(integration_id, is_filter) {
        this.loading_data = true;
        this.import_courses_modal = true;
        const payload = {
          next_page: this.next_page,
          filters: this.filters,
        };
        return adminServices
          .getEdlinkSchoolIntegrationTeachers(
            this.$route.params.schoolID,
            integration_id,
            payload
          )
          .then(({ data }) => {
            if (is_filter) {
              this.teachers = [];
            }
            this.teachers.push(...data.teachers);
            this.next_page = data.next_page;
            if (this.next_page) {
              this.show_more_teachers = true;
            } else {
              this.show_more_teachers = false;
            }
            this.integration_id = integration_id;
            this.loading_data = false;
          })
          .catch((err) => {
            this.loading_data = false;
            console.error(err);
          });
      },
      searchAndFilters(value) {
        this.filters = value;
        this.next_page = '';
        // this.getEdlinkSchoolIntegrationCourses(
        //   this.integration_id,
        //   this.integration_name,
        //   this.page_number,
        //   true
        // );
        this.getEdlinkSchoolIntegrationTeachers(this.integration_id, true);
      },
      resetFilters() {
        this.courses = [];
        this.show_more_courses = true;
        this.page_number = 1;
        this.teachers = [];
        this.show_more_teachers = true;
      },
      resetCourses() {
        this.resetFilters();
        // this.filters = {
        //   course_title: '',
        //   teacher_email: '',
        //   subject: '',
        //   school_site: '',
        //   grade: '',
        //   is_connected: '',
        // };
        this.filters = {
          first_name: '',
          last_name: '',
          teacher_email: '',
          parlay_account: '',
        };
        this.import_courses_modal = false;
      },
      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);
        return (
          element.scrollHeight - Math.floor(element.scrollTop) ===
            element.clientHeight ||
          element.scrollHeight - Math.round(element.scrollTop) ===
            element.clientHeight
        );
      },
      handleScroll() {
        // if (
        //   this.elementHasReachedScrollEnd('integrations-course-modal') &&
        //   this.show_more_courses
        // ) {
        //   this.getEdlinkSchoolIntegrationCourses(
        //     this.integration_id,
        //     this.integration_name,
        //     page_number,
        //     false
        //   );
        // }
        if (
          this.elementHasReachedScrollEnd('integrations-teacher-modal') &&
          this.show_more_teachers
        ) {
          this.getEdlinkSchoolIntegrationTeachers(this.integration_id, false);
        }
      },
    },
    mounted() {
      this.getEdLinkMetadata();
      this.getEdlinkProviders();
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .integrations-container
    padding: 3.1rem 2rem 0 2rem
  .integrations-header
    line-height: 22px
    font-size: 18px
    color: #273248
  .enable-integrations
    color: #5FA95C
    border-bottom: 2px solid #d9d9d9;
    border-right: 2px solid #d9d9d9;
</style>



// WEBPACK FOOTER //
// adminPortalIntegrations.vue?baea6bbe